import React from "react"
import { useSelector } from "react-redux"
// Components
import Category from "../Category/Category"
// Data
import { categories as data } from "../../data"
// Styles
import { Container } from "./Categories.styles"

const Categories = () => {
    const language = useSelector((state) => state.environment.language)

    let categories = []
    for (let i = 0; i < data.length; i++) {
        categories.push({
            id: data[i].id,
            title: (language === "fr") ? data[i].titleFr : data[i].titleEn,
            img: data[i].img,
            category: data[i].category
        })
    }

    return (
        <Container>
            {categories.map(item => (
                <Category item={item} key={item.id} />
            ))}
        </Container>
    )
}

export default Categories
